/* global bocAmchart */


/**
 * Reset the valueSuffix (for % charts), must be called after rendering the chart
 * to avoid inheriting the setting in other charts
 * @return {void}
 */
bocAmchart.resetValueSuffix = function () {
    // eslint-disable-next-line no-console
    console.log("resetValueSuffix is not necessary");
};

/**
 * Configure the chart to display values as percentages
 * @param {object} chartSettings Object
 * @return {void}
 */
bocAmchart.setPercentageChart = function (chartSettings) {
    if (chartSettings.hasOwnProperty('valueAxes')) {
        var valueSuffix = '';
        if (window.chartLanguage === 'fr') {
            valueSuffix = ' ';
        }
        valueSuffix += '%';

        chartSettings.valueAxes[0].unit = valueSuffix;

        bocAmchart.initChartVars(chartSettings);
        bocAmchart.vars[chartSettings.bocSettings.id]['valueSuffix'] = valueSuffix;
    }
};